import React from 'react';
import ReactModal from 'react-modal';

import Icon from '../../../components/icon/Icon';
import { isMobileScreenSize } from '../../../core/utils/isMobileScreenSize';

import './Modal.scss';

export type ModalSize = 'extra-small' | 'small' | 'medium' | 'large';

interface Props {
  isOpen: boolean;
  size?: ModalSize;
  closeModal: () => void;
  title?: React.ReactNode;
  height?: number;
  toolbar?: React.ReactNode;
  transparentOverlay?: boolean;
  isFullScreen?: boolean;
  className?: string;
}

const Modal: React.FC<Props> = ({
  isOpen,
  size = 'small',
  closeModal,
  children,
  title,
  toolbar,
  height,
  transparentOverlay = false,
  isFullScreen,
  className
}) => {
  const overlayStyle = {} as React.CSSProperties;
  const contentStyle = {} as React.CSSProperties;
  const isMobileScreen = isMobileScreenSize();

  if (transparentOverlay) {
    overlayStyle.backgroundColor = 'transparent';
  }

  if (isFullScreen) {
    contentStyle.width = '100%';
    contentStyle.height = '100%';
  }
  overlayStyle.zIndex = 2;

  return (
    <ReactModal
      style={{
        overlay: {
          ...overlayStyle
        },
        content: {
          height,
          ...contentStyle
        }
      }}
      className={`modal modal--${size} ${isMobileScreen && 'modal--mobile'} ${className}`}
      isOpen={isOpen}
      onRequestClose={closeModal}
    >
      <div className="modal__header">
        {title && <div className="modal__header-inner">{title}</div>}
        <div className="modal__close">{closeModal && <Icon size="full-size" onClick={closeModal} icon="x" isButton svg />}</div>
      </div>
      <div className="modal__content">{children}</div>
      {toolbar && <div className="modal__toolbar">{toolbar}</div>}
    </ReactModal>
  );
};

export default Modal;
